var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthermint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6ecf2;}.b{fill:#ccd9e6;}.c{fill:#8ca9c6;}.d{fill:#369;}.e{opacity:0.25;}.f{fill:#004080;}.g{fill:#3d6b99;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M191.68,203.7,250,238.13V107Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250,107V238.13l58.3-34.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M191.68,214.74,250,296.84V249.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250,249.17v47.67l58.34-82.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M250,177.19,191.68,203.7,250,238.13l58.3-34.43Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M263.52,166A36.67,36.67,0,0,0,250,163.42a36.17,36.17,0,0,0-25.83,10.79,36.94,36.94,0,0,0-10.75,25.92v1.32l1.14.65a36.42,36.42,0,0,0,18,4.77h.52A36.93,36.93,0,0,0,249,203a37.54,37.54,0,0,1-4.45-2.93A32.24,32.24,0,0,1,218,198.83,32.14,32.14,0,0,1,263.76,171a29.63,29.63,0,0,0-.24-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M286.72,199.85a36.78,36.78,0,0,0-15.9-30.1,36.76,36.76,0,0,1-.36,5.34,32.26,32.26,0,0,1,11.74,23.46,32.17,32.17,0,0,1-46.69-25.75,31,31,0,0,0-4.17,2.75,37,37,0,0,0,4.45,12.66,36.42,36.42,0,0,0,49.8,13.62l1.14-.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M251.35,137.93l-1.13-.66-1.13.66a36.94,36.94,0,0,0-18.17,29.35,38.56,38.56,0,0,1,4.76-2.4,32.71,32.71,0,0,1,14.54-22.39,32.49,32.49,0,0,1,1.14,53.71,31.29,31.29,0,0,0,4.44,2.24,37,37,0,0,0-4.45-60.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthermint);
export default __webpack_public_path__ + "static/media/ethermint.20f410ba0305682605249505f4a497ac.svg";
export { ForwardRef as ReactComponent };